import { request } from '@kibt/krn-utils';
import { api } from '@/common/api';
import { isLogin } from '@/common/const';
import { useRequest } from 'ahooks';
// import { request } from './request';

export const APPID = '1';

export const BIZ_TYPE = '1';

export const VERSION = '1';

export const getEncryptionFormat = (algorithm = 1) => {
    return {
        algorithm,
        appId: APPID,
        bizType: BIZ_TYPE,
        version: VERSION,
    };
};

export interface PriceDiscountDetail {
    flashSaleDeductAmount: number;
    distributorDeductAmount: number;
    itemCouponDeductAmount: number;
    displayFlashSaleDeductAmount: string;
    displayDistributorDeductAmount: string;
    displayItemCouponDeductAmount: string;
}

export interface Activity {
    activityId: number;
    status: number;
    endTime: number;
    endTimeStamp: number;
    stock: number;
    skuLimitCount: { [key: string]: number };
    skuPurchasableCount: any;
    saleRate: number;
    displayStock: string;
    marketingActivityType: number;
    threshold: number;
    displayThreshold: string;
    discountAmount: number;
    displayDiscountAmount: string;
}
export interface CurrentTier {
    discount: number;
    displayDiscount: string;
    displayShippingFeeAfterDiscount: string;
    displayThreshold: string;
    marketingActivityType: (1 | 4002)[]; // 1-券，4002-商家运费折扣
    shippingFeeAfterDiscount: number;
    threshold: number;
    tier: number;
}

export interface ShippingFeeDiscountTier {
    discount: number;
    displayDiscount: string;
    displayShippingFeeAfterDiscount: string;
    displayThreshold: string;
    marketingActivityType: (1 | 4002)[]; // 1-券，4002-商家运费折扣
    shippingFeeAfterDiscount: number;
    threshold: number;
    tier: number;
}

export interface ShippingFeeInfo {
    currentTier: CurrentTier;
    displayExpressFee: string;
    displayMaxDiscount: string;
    displayMinDiscount: string;
    expressFee: number;
    marketingActivityType: number[];
    maxDiscount: number;
    minDiscount: number;
    shippingFeeDiscountTier: ShippingFeeDiscountTier[];
}

export interface PhotoInfo {
    photoId: number;
    photoCoverUrl: string;
    photoUrl: string;
    deeplink: string;
}

export interface Spec {
    specId: number;
    specName: string;
    specSortNum: number;
    itemSpecValues: ItemSpecValue[];
}

export interface ItemSpecValue {
    specId: number;
    specValueId: number;
    specValueName: string;
    specValueSortNum: number;
    imageUrl: string;
    templateImageUrl: string;
}

export interface Sku {
    skuId: number;
    itemId: number;
    skuSpecDesc: string;
    merchantId: number;
    skuPrice: number;
    skuMarketPrice: number;
    shippingFee: number;
    imageUrl: string;
    templateImageUrl: string;
    availableQuantity: number;
    createTime: number;
    updateTime: number;
    displaySkuPrice: string;
    displaySkuMarketPrice: string;
    displayShippingFee: string;
    displayAvailableQuantity: string;
    displayPriceOff: string;
    salePrice: number;
    displaySalePrice: string;
    activityPrice: number;
    displayActivityPrice: string;
    discountRate: number;
    skuSpecs: SkuSpec[];
    priceDiscountDetail: PriceDiscountDetail;
    activityLimitCount?: number;
}

export interface SkuSpec {
    specId: number;
    specName: string;
    specSortNum: number;
    specValueId: number;
    specValueName: string;
    specValueSortNum: number;
    imageId: string;
    imageUrl: string;
    templateImageUrl: string;
    itemId: number;
    skuId: number;
    createTime: number;
    updateTime: number;
}

export interface SellerMerchantShop {
    shopId: number;
    merchantId: number;
    userStatus: number;
    imgUrl: string;
    smallImgUrl: any;
    shopName: string;
    commodityCount: number;
}

export interface PromotionView {
    itemId: number;
    promotionId: number;
    feeType: number;
    discountMode: number;
    discountType: number;
    maxDiscountAmount: number;
    rule: any[];
    marketingActivityType: number;
}

export interface ExtraInfo {
    selfOperated: boolean;
    salePriceInclude: any[];
    returnCoin: number;
    returnCoinImageUrl: string;
    displayReturnCoin: string;
    // NOT_IN_ACTIVE_TIME_RANGE-无活动氛围，WARM_UP-预热氛围，IN_PROGRESS-活动期氛围
    atmosphereTimeNode: 'NOT_IN_ACTIVE_TIME_RANGE' | 'WARM_UP' | 'IN_PROGRESS';
    benefit: (1 | 2 | 3)[]; // 利益点1-本地发货，2-券包邮，3-商家包邮
}

export interface PageUrl {
    placeOrderJumpUrl: string;
    shopJumpUrl: string;
}

export interface ServiceRule {
    logisticsType: number;
    expressFeeType: number;
    expressFee: number;
    displayExpressFee: string;
    expressFeeAfterDiscount: number;
    displayExpressFeeAfterDiscount: string;
    deliveryDurationPercentile: number;
    deliveryDurationDay: number;
    defaultDisplayMessage: string;
}

export interface Address {
    addressContent: string;
    postalCode: string;
    provinceName: string;
    cityName: string;
    districtName: string;
    countryCode: string;
    secretKey: SecretKey;
}

export interface SecretKey {
    key: string;
    iv: string;
}

export interface ShopControl {
    hasShop: boolean;
    shopIcon: string;
}

export interface Shop {
    shopId: number;
    merchantId: number;
    userStatus: number;
    imgUrl: string;
    smallImgUrl: string;
    shopName: string;
    commodityCount: number;
}

export interface RecoItem {
    itemId: number;
    title: string;
    imageUrl: string;
    templateImageUrl: string;
    displayItemPrice: string;
    displayMarketPrice: string;
    itemPrice: number;
    marketPrice: number;
    currency: string;
    activeStatus: number;
    auditStatus: number;
    salePrice: number;
    displaySalePrice: string;
    activityInfo: any;
    activityPrice: number;
    displayActivityPrice: string;
    salePriceInclude: any;
    discountRate: number;
    serviceRule: ServiceRule;
    jumpUrl: string;
    shop: any;
    discountCoupon: any[];
    totalSoldQuantity: number;
    productDetailJumpUrl: string;
    display: boolean;
}

export interface InstallmentVo {
    installment: number;
    paymentPerInstallment: number;
    interestPerInstallment: number;
    displayPaymentPerInstallment: string;
    displayInterestPerInstallment: string;
    skuId: number;
}

export interface SkuInstallment {
    installment: number;
    paymentPerInstallment: number;
    interestPerInstallment: number;
    displayPaymentPerInstallment: string;
    displayInterestPerInstallment: string;
    skuId: number;
}

export interface BigSaleInfoVo {
    saleName: string;
    salePeroid: string;
    endTimeStamp: number;
    endTimeLeft: number;
    warmUpPrice: number;
    displayWarmUpPrice: string;
    discountRate: number;
}

export interface Comment {
    commentId: number;
    productScore: number;
    detail: string;
    imageUrl: string[];
    userName: string;
    userHeadUrl: string;
    anonym: boolean;
    skuSpecDesc: string;
    createTime: number;
}

export interface TagCnt {
    value: string;
    amount: number;
    displayAmount: string;
}

export interface TotalCommentCnt {
    amount: number;
    displayAmount: string;
}

export interface TagInfoAgg {
    priceTag: any[];
    itemTag: any[];
    merchantTag: any[];
}

export interface PageRowData {
    title: string;
    itemId: number;
    merchantId: number;
    saleCountry: string;
    imageUrls: string[];
    itemImageUrl: any;
    templateImageUrl: any;
    itemPrice: number;
    marketPrice: number;
    totalQuantity: number;
    totalSoldQuantity: number;
    shippingFeeInfo: ShippingFeeInfo;
    displayItemPrice: string;
    displayMarketPrice: string;
    salePrice: number;
    displaySalePrice: string;
    activityPrice: number;
    displayActivityPrice: string;
    displayTotalQuantity: string;
    displayTotalSoldQuantity: string;
    specs: Spec[];
    skus: Sku[];
    sellerMerchantShop: SellerMerchantShop;
    discountCoupon: any;
    activityInfo: any;
    activityList: Activity[];
    salePriceInclude: any;
    promotionView: PromotionView;
    minPurchase: number;
    extraInfo: ExtraInfo;
    abTest: {
        addCartOnly: boolean; // 仅加购实验
        multipulButtonForSpecHalfScreen: boolean; // 仅加购情况下加购规格弹窗在达到运费券门槛时是否支持「购买」按钮
        plcStyle: 0; // plc样式
        productDetailPictureUgcLoop: 1;
        waitingTimeNoOperation: 0;
        coolingTimePopup: 2;
        goodReviews: boolean; // 全部商品评价页的好评优先展示、差评沉底折叠、个人评价置顶 https://docs.corp.kuaishou.com/d/home/fcAA6jTgd2KExLTK2JtF7ZytG#section=vodka.qqbcjn1912h0
        ratingFloorHeight: boolean; // 商详页缩短评价楼层，只展示一条评价 https://docs.corp.kuaishou.com/d/home/fcAA6jTgd2KExLTK2JtF7ZytG#section=vodka.qqbcjn1912h0
        wordOfMouth: boolean; // 商品主图的优质好评图、tab筛选功能 https://docs.corp.kuaishou.com/d/home/fcAA6jTgd2KExLTK2JtF7ZytG#section=vodka.qqbcjn1912h0
        [key: string]: any;
    };
    makeUpCoupon: any;
    shippingFeeView: any;
    pageUrl: {
        [key: string]: string;
    };
    categoryIdList: number[];
    description: string;
    templateImageUrls: string[];
    detail: string;
    returnRuleId: number;
    serviceRule: ServiceRule;
    address: Address;
    activeStatus: number;
    itemNewsTickers: any;
    shopControl: ShopControl;
    shop: Shop;
    recoItems: RecoItem[];
    simpleFreeShipping: boolean;
    expireCoupon: any;
    installmentVO: InstallmentVo;
    skuInstallments: SkuInstallment[];
    displayPriceOff: string;
    displayShoppingCart: boolean;
    displaySpuUgc: string;
    bigSaleInfoVO: BigSaleInfoVo;
    retrievalInfo: any;
    comments: Comment[];
    tagCnt: TagCnt[];
    totalCommentCnt: TotalCommentCnt;
    productDetailJumpUrl: any;
    tagInfoAgg: TagInfoAgg;
    tags: any;
    photoInfo: PhotoInfo;
    priceDiscountDetail: PriceDiscountDetail;
    isCache: boolean;
}

/**
 *  查询商品详情数据
 */
export function getDetailData(params: {
    scene: number | string;
    itemId: number | string;
    encryptedParam: any;
    merchantId?: number | string;
    sellerUserId?: number | string;
    extParams?: string;
    photoId?: number | string;
}) {
    return request
        .get(api('/rest/o/ecom/customer/item/info'), {
            params,
        })
        .then((res) => {
            if (res.result === 1) {
                return res;
            } else {
                return Promise.reject(res);
            }
        });
}
/**
 *  查询商品详情数据-简单版，用于加购规格弹窗
 */
export function useGetDetailDataSimple(params: {
    itemId: number | string;
    encryptedParam: any;
    merchantId?: number | string;
    sellerUserId?: number | string;
    scene?: number | string;
}) {
    const { data, runAsync: getDetailDataSimple } = useRequest(
        () =>
            request.get(api('/rest/o/ecom/customer/item/simpleInfo'), {
                params,
            }),
        {
            cacheKey: `simpleInfo-${params.itemId}`,
            manual: true,
        },
    );
    return { data, getDetailDataSimple };
}

/**
 *  催下单
 */
export function postRemindBuyMsg(params: { itemId: number | string; merchantId?: number | string }) {
    return request.post(api('/rest/o/ecom/customer/cs/item/remind'), {
        ...params,
    });
}

/**
 * 查询AES加密参数
 */
export function getAesKey(params: { appId: string; bizType: string; version: string }) {
    return request.post(api('/rest/o/ecommerce/privacy/encryption/aes/param/query'), params);
}

let forge: any;
export async function getForge() {
    if (!forge) {
        const _forge = await import(/* webpackChunkName: "forge-lib" */ '@/common/utils/forgeLib');
        forge = _forge.default || _forge;
    }
    return forge;
}

export async function decodeByAes(iv: string, key: string, data: string) {
    const forge = await getForge();

    const decipher = forge.cipher.createDecipher('AES-CBC', forge.util.decode64(key));
    decipher.start({ iv });
    decipher.update(forge.util.createBuffer(forge.util.decode64(data)));
    const result = decipher.finish(); // check 'result' for true/false

    if (!result) {
        throw new Error('解密失败');
    }
    return decipher.output.toString();
}

export async function decodeData(
    data: string,
    options: {
        // 加密要用的算法 1: aes | 2: rsa
        algorithm: number;
        // 加密算法要用的参数，目前后端没要求，可以随便填
        appId: string;
        bizType: string;
        version: string;
    },
) {
    if (options.algorithm === 1) {
        // 获取秘钥
        const res = await getAesKey(options);
        const { iv, key } = res.data;
        // 解密
        return decodeByAes(iv, key, data);
    }
    throw new Error('not support');
}

export async function decodeDataV2(
    data: string,
    secretKey: {
        key: string; // AES秘钥
        iv: string; // 初始向量
    },
) {
    if (secretKey.iv && secretKey.key) {
        return decodeByAes(secretKey.iv, secretKey.key, data);
    }

    throw new Error('lack of aes params');
}

export async function getDecodeDataV2(content: any) {
    return JSON.parse(await decodeData(content, getEncryptionFormat()));
}

// 后端返回了密钥，少请求一次接口
export async function getDecodeDataV3(response: any) {
    const {
        data: { content, secretKey },
    } = response;
    response.data = JSON.parse(await decodeDataV2(content, secretKey));
    return response;
}

export async function getDecodeData(response: any) {
    const { data } = response || {};
    const { content, encryptionFormat } = data || {};
    response.data = JSON.parse(await decodeData(content, encryptionFormat));
    return response;
}

/**
 * @function 查询用户收货地址
 */
export function postAddressQueryApiV2(params: { addressId?: number | null }) {
    return request
        .post(api('/rest/o/ecommerce/privacy/encrypt/customer/address/query'), {
            ...params,
            encryptionFormat: getEncryptionFormat(),
        })
        .then((res) => getDecodeData(res));
}
/**
 * @function 查询用户收货地址列表 deliveryAvailableParameters:这个用来给服务端那边判断是不是需要返回是否能配送的字段
 */
export function postAddressQueryApiV3(
    deliveryAvailableParameters: {
        merchantId: number;
        itemId: number;
        skuId: number;
    } | null,
) {
    // 未登录下不允许调用地址列表
    if (!isLogin) {
        return Promise.reject({});
    }
    return request
        .post(api('/rest/o/ecommerce/privacy/encrypt/customer/address/queryByUserId'), {
            deliveryAvailableParameters,
            encryptionFormat: getEncryptionFormat(),
        })
        .then((res) => {
            if (res.result === 1) {
                return getDecodeDataV3(res);
            } else {
                return Promise.reject(res);
            }
        });
}

// 查询运费接口
export function getFreightCharge(params: { addressId: number | null; postCode: string | null; itemId: number }) {
    // 过滤空值
    function filterEmptyValues(obj) {
        return Object?.keys(obj)?.reduce((acc, key) => {
            if (obj[key] !== null) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    const filterParams = filterEmptyValues(params);
    return request.get(api('/rest/o/ecom/customer/item/expressFee'), { params: filterParams }).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}

export enum FreightChargeStatus {
    Success = 'success',
    Error = 'error',
}

/**
 * 获取商品详情页点击buy时商铺状态
 */
export function getBuyShopStatus(params: { itemId: string | number; skuId: string | number; extParams: string }) {
    return request.get(api('/rest/o/ecom/customer/item/status'), { params }).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}

/**
 * 领取优惠券
 */
export function claimSelfBuildCoupon(params: { batchId: number | string }) {
    return request.post(api(`/rest/o/ecommerce/marketing/c/customer/coupon/claim?batchId=${params.batchId}`)).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}

/**
 * 批量领取优惠券
 */
export function claimSelfMultiBuildCoupon({ batchIds }) {
    return request
        .post(api('/rest/o/ecommerce/marketing/c/customer/coupon/claim/multi'), {
            batchIds,
        })
        .then((res) => {
            if (res.result === 1) {
                return res;
            } else {
                return Promise.reject(res);
            }
        });
}

// 商详页查询优惠劵列表
export function getQueryDetailCouponListAPI(params) {
    // return axios.post(api('/rest/o/ecommerce/marketing/c/customer/coupon/item/list'), params).then((response) => response.data);
    return request.post(api('/rest/o/ecommerce/marketing/c/customer/coupon/item/list'), params).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}

export function postDistributeSelectionAddSelf(params: { itemIds: (number | string)[] }) {
    return request.post(api('/rest/o/ecom/customer/distribute/shelf/add'), params, {}).then((res) => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}

export function getToBDetailData(params: { itemId: number | string }) {
    return request.get(api('/rest/o/ecom/customer/shelf/seller/item/info'), { params });
}

export function postAddToCart(params: {
    skuId: number;
    skuQuantity: number; // 加购数量
    itemId: string | number;
    merchantId: number;
    // 加购链路埋点
    mediaId?: string;
    mediaSource?: string;
    mediaDetailSource?: string;
    sellerMerchantId?: number;
    recoDetail?: {
        expTag: string;
        llsid: string;
    };
}) {
    return request.post(api('/rest/o/ecommerce/customer/shopCart/addCartItem'), params);
}

// 购物车凑单页半屏加购接口
export function postAddCartItemWithMakeUp(params: {
    selected: any;
    recommendCartItemList: any;
    skuId: number;
    skuQuantity: number; // 加购数量
    itemId: string | number;
    merchantId: number;
    // 加购链路埋点
    mediaId?: string;
    mediaSource?: string;
    mediaDetailSource?: string;
    sellerMerchantId?: number;
}) {
    return request.post(api('/rest/o/ecommerce/customer/shopCart/addCartItemWithMakeUp'), params, { toastError: false });
}
